import React, { useState, useMemo } from "react";
import { IReducer } from "../../state/reducer";
import PrimaryFilter from "../PrimaryFilter/PrimaryFilter";
import { ActionEntry } from "../../state/BrickActions/ActionEntries";
import BrickPackRow from "../BrickPackRow/BrickPackRow";
import "./brickpack.css";

const BrickPack: React.FC<IReducer> = ({ state, dispatch }) => {
  const [activeSearch, setActiveSearch] = useState<string>("");

  // Memoized computation of visible actions
  const visibleBrickpacks = useMemo(() => {
    let filteredActions: ActionEntry[] = [];

    state.actions.forEach((actionEntry, key) => {
      if (
        actionEntry &&
        actionEntry.visible &&
        actionEntry.isBrickpack &&
        !Number.isNaN(key)
      ) {
        filteredActions.push(actionEntry);
      }
    });

    // Apply search filter
    if (activeSearch.trim() !== "") {
      filteredActions = filteredActions.filter((action) =>
        action.title.toLowerCase().includes(activeSearch.toLowerCase()),
      );
    }

    return filteredActions;
  }, [state.actions, activeSearch]);

  return visibleBrickpacks.length > 0 ? (
    <div className="moduleContainer">
      <div className="inventoryHeader">
        <div className="headerContent">
          <div className="inventoryHeaderTitle">Brick Packs</div>
        </div>
      </div>
      <div className="brickPacks">
        {visibleBrickpacks.slice().map((action, index) => (
          <BrickPackRow
            key={index}
            id={action.id}
            title={action.title}
            type={action.type}
            details={action.details}
            state={state}
            dispatch={dispatch}
          />
        ))}
      </div>
      <div className="inventoryFooter">
        <PrimaryFilter placeholder="Search" setActiveSearch={setActiveSearch} />
      </div>
    </div>
  ) : null;
};

export default BrickPack;
